import { Directive, ElementRef, SimpleChanges, inject, input } from '@angular/core';
import { SessionService } from '../services/session.service';

@Directive({
  selector: '[openLink]',
  standalone: false
})
export class OpenLinkDirective {
  readonly openLink = input<ElementRef>(undefined);
  session = inject(SessionService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['openLink'] && changes['openLink'].currentValue) {
      this.open();
    }
  };

  open() {
    const openLink = this.openLink();
    if (openLink && !this.session.isMobileDevice) {
      openLink.nativeElement.click();
    }
  };
}
